@if (availableLocale.length > 1) {
  @if (mode=='row') {
    <div data-test-id="locale-picker-lib-locale"  class="lib-locale">
      @if ((config$|async); as config) {
        <div data-test-id="locale-picker-simple"  class="simple-row">
          @for (locale of availableLocale; track locale) {
            <a [attr.data-test-id]="'locale-picker-lib-'+locale" role="button" (click)="changeLang(locale, config)" [class.active]="(activeLocale$ | async) == locale">
              {{ getDisplayLocale(locale) }}
            </a>
          }
        </div>
      }
    </div>
  } @else {
    @if ((config$|async); as config) {
      <div data-test-id="locale-picker-locale"  class="lib-locale">
        <button data-test-id="locale-picker-text-button"  class="ee-text-button" [matMenuTriggerFor]="localeMenu" #open="matMenuTrigger">
          <img data-test-id="locale-picker-img"  src="/assets/synlab-header/globe-icon.png" alt="globe icon">
          {{ activeLocale$ | async  }}
          @if (open.menuOpen==false) {
            <mat-icon data-test-id="locale-picker-icon"  color="primary">keyboard_arrow_down</mat-icon>
          }
          @if (open.menuOpen==true) {
            <mat-icon data-test-id="locale-picker-icon"  color="primary">keyboard_arrow_up</mat-icon>
          }
        </button>
        <mat-menu data-test-id="locale-picker-localeMenu"  #localeMenu="matMenu">
          @for (locale of availableLocale; track locale; let i = $index) {
            <button [attr.data-test-id]="'locale-picker-locale-locale'+i"  mat-menu-item class="lib-locale-locale" [class.use-flags]="useFlags" (click)="changeLang(locale, config)" [class.active]="(activeLocale$ | async) == locale">
              <mat-icon data-test-id="locale-picker-icon"   color="primary">check</mat-icon>
              {{ locale | slice: 0: 2 }}
              @if (useFlags) {
                <span data-test-id="locale-picker-span"  [ngClass]="['fp', lookupCountry(locale)]"></span>
              }
            </button>
          }
        </mat-menu>
      </div>
    }
  }
}


